import { render } from "./Shimua.vue?vue&type=template&id=543f3e79&scoped=true"
import script from "./Shimua.vue?vue&type=script&lang=js"
export * from "./Shimua.vue?vue&type=script&lang=js"

import "./Shimua.vue?vue&type=style&index=0&id=543f3e79&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-543f3e79"]])

export default __exports__